import React from 'react';
import { usePlanningSearch } from '../state/PlanningSearchContext';
import { usePlanningContext } from '../state/PlanningContext';

export default function LondonSourceFilters({ onClear }: { onClear?: () => void } = {}) {
  const search = usePlanningSearch();
  const context = usePlanningContext();
  return <div className="pr-panel space-y-3 p-4">
    <label className="block text-sm">Search official records
      <input className="mt-1 block w-full border border-[var(--c-border)] bg-[var(--c-bg)] p-2"
        aria-label="Search London planning applications" placeholder="Reference, address or proposal" maxLength={100}
        value={search.searchInput || search.searchTokens.join(' ')}
        onChange={(e) => { if (search.searchTokens.length) search.clearTokens(); search.setSearchInput(e.target.value); }} />
    </label>
    <div className="flex flex-wrap items-end gap-3 text-sm">
      <label>Validated from<input aria-label="Validated from" type="date"
        className="mt-1 block border border-[var(--c-border)] bg-[var(--c-bg)] p-2"
        value={search.facetState.dateFrom || ''}
        onChange={(e) => search.setCustomDateRange(e.target.value || null, search.facetState.dateTo)} /></label>
      <label>Validated through<input aria-label="Validated through" type="date"
        className="mt-1 block border border-[var(--c-border)] bg-[var(--c-bg)] p-2"
        value={search.facetState.dateTo || ''}
        onChange={(e) => search.setCustomDateRange(search.facetState.dateFrom, e.target.value || null)} /></label>
      <button className="pr-button" onClick={onClear || search.clearAll}>Clear filters</button>
    </div>
    <p className="text-xs text-[var(--c-text-secondary)]">Dates use the council's validation date. Applications without a mapped location are included in these results.</p>
    <a className="inline-block text-sm underline" href={`/planning-map/${context.councilSlug}`}>View these council records on the planning map</a>
  </div>;
}
